import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Merchant } from '../../models/merchant';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-online-status',
    templateUrl: './online-status.component.html',
    styleUrls: ['./online-status.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class OnlineStatusComponent implements OnChanges {
  @ViewChild('myNetwork', { static: false }) private myNetwork; // Reference to the myNetwork template
  @Input() onlineStatusMessage: string; // Input to receive the online status message
  @Input() onlineStatus: string; // Input to receive the online status (e.g., "online" or "offline")
  @Input() Merchant: Merchant; // Input to receive the Merchant object

  constructor(private modalService: NgbModal) {}

  /**
   * Lifecycle hook that is called when there are changes to the input properties.
   * @param changes An object containing the changed input properties.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (this.onlineStatus === "offline") {
      // If the online status is "offline", open the myNetwork modal
      this.modalService.open(this.myNetwork, {
        centered: true,
        scrollable: true,
        backdrop: 'static' // Prevent closing the modal by clicking outside
      });
    } else if (this.onlineStatus === "online") {
      // If the online status is "online", dismiss all open modals
      this.modalService.dismissAll();
    }
  }

  /**
   * Lifecycle hook that is called after the component has been initialized.
   */
  ngOnInit() {
    // Any initialization logic can be added here
  }

  /**
   * Method to handle the "reconnect" action.
   * If the online status is "online", dismiss all open modals.
   */
  reconnect() {
    if (this.onlineStatus === "online") {
      this.modalService.dismissAll(); // Dismiss all open modals
    }
  }
}

